module.exports = __webpack_public_path__ + "img/WeightWarningMessage.d997a394.png";